import { getUserFields, getdirectusUserFields } from "components/user/config";
import { updateItemInCollection } from "directus/src/operations";

export async function updateTicket({ ticketId, item }) {
  console.log(ticketId)
  try {
    const query = {
      fields: [
        "id",
        "title",
        "status",
        "type",
        "description",
        "attachments.attachment.id",
        "attachments.attachment.type",
        // "response",
        getUserFields("assigned_to"),
        getdirectusUserFields("user_created"),
        getdirectusUserFields("user_updated"),
        "priority",
        "date_created",
        "date_updated",
        "due_date",
      ],
    };

    const data = await updateItemInCollection(
      "tickets",
      ticketId,
      item,
      query
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
